import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="font-heading text-2xl uppercase tracking-widest text-padel-blue animate-pulse-glow">Cargando…</div>
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
